import React, { useCallback, useEffect, useState } from "react";
import jwt_decode from "jwt-decode";

import { IDropdownItem } from "../../_types_";
import { layKhungGiaDatMetadataApi } from "../../apis/khung.gia.dat.api";
import { hasEditPermissionApi } from "../../apis/role.api";

interface IGlobalContext {
  loaiDats: IDropdownItem[];
  khuVucs: IDropdownItem[];
  accessToken?: string;
  isHasEditRole: boolean;
  setRole?: (role: boolean) => void;
}

interface ProviderProps {
  children: React.ReactNode;
}

const GlobalContext = React.createContext<IGlobalContext>({
  loaiDats: [],
  khuVucs: [],
  isHasEditRole: false,
});

export const GlobalContextProvider: React.FC<ProviderProps> = ({
  children,
}) => {
  const [loaiDats, setLoaiDats] = useState<IDropdownItem[]>([]);
  const [khuVucs, setKhuVucs] = useState<IDropdownItem[]>([]);
  const [isHasEditRole, setHasEditRole] = useState<boolean>(false);

  const getInitialState = useCallback(async () => {
    try {
      const token = window.localStorage.getItem("accessToken");
      var decoded: any = jwt_decode(token || "");
      const user = decoded.email;
      const hasEditRole = await hasEditPermissionApi(user);
      setHasEditRole(hasEditRole);
      const rs = await layKhungGiaDatMetadataApi();

      let temp: IDropdownItem[] = rs.loaiDats.map((p: any) => {
        const item: IDropdownItem = {
          value: p.maLoaiDat,
          lable: p.tenLoaiDat || p.maLoaiDat,
        };
        return item;
      });
      setLoaiDats(temp);

      const temp1 = rs.loaiKhuVucs.map((p: any) => {
        const item: IDropdownItem = {
          value: p.id,
          lable: p.ten,
        };
        return item;
      });
      setKhuVucs(temp1);
    } catch (er) {}
  }, []);

  useEffect(() => {
    getInitialState();
  }, [getInitialState]);

  return (
    <GlobalContext.Provider
      value={{
        loaiDats,
        khuVucs,
        isHasEditRole,
        setRole: (v) => setHasEditRole(v),
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => React.useContext(GlobalContext);
